export { Body2 } from './Body2';
export { body2ClassNames } from './useBody2Styles.styles';
